import { findIndex, set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  fetchGuestNotes,
  createGuestNote,
  updateGuestNote,
  deleteGuestNote
} from '../../../sagas/routines';
import { clearGuestNotes } from '../../actions/note';
import { createDeleteHandler } from '../../../../helpers/reducerRoutineCrudHandler';

const initialState = {
  all: [],
  meta: { page: 1, total: 0 },
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null
};

const fetchGuestNotesHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: [...state.all, ...response.items],
    meta: response.meta
  }),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const createGuestNoteHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: [response, ...state.all]
  }),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const updateGuestNoteHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const noteKey = findIndex({ id: response.id }, state.all);
    return {
      ...state,
      all: set(noteKey, response, state.all)
    };
  },
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearGuestNotesHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchGuestNotesHandler(fetchGuestNotes),
  ...createGuestNoteHandler(createGuestNote),
  ...updateGuestNoteHandler(updateGuestNote),
  ...clearGuestNotesHandler(clearGuestNotes),
  ...createDeleteHandler(deleteGuestNote)
});
